import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useKeycloak } from '@react-keycloak/web';
import { WrapperTotalTickets } from './styles';
import TotalByStatus from './TotalByStatus';
import TotalByTotal from './TotalByTotal';
import Loader from '../../loader';
import { getTotalTickets, getGraphicTickets, getGraphicPerWeekTickets, openTicketModal } from '../../../store/fuse/nivelService';
import { getNotifications } from '../../../theme-layouts/shared-components/notificationPanel/store/dataSlice';

import TicketsModal from './TicketsModal';

const Index = () => {
  const dispatch = useDispatch();
  const { keycloak } = useKeycloak();

  const id = keycloak?.tokenParsed?.sub;
  const roleId = keycloak?.tokenParsed?.resource_access?.puv.roles[0];

  const initTotalTickets = () => dispatch(getTotalTickets());
  const initGraphicTickets = () => dispatch(getGraphicTickets());
  const initGraphicPerWeekTickets = () => dispatch(getGraphicPerWeekTickets());
  const dataNivelService = useSelector((state) => state.fuse?.nivelService);
  const loaderTickets = useSelector((state) => state?.fuse?.nivelService?.loading);
  const loaderTotalTickets = useSelector((state) => state?.fuse?.nivelService?.loadingTicket);
  const loaderTotalWeekTickets = useSelector((state) => state?.fuse?.nivelService?.loadingTicketWeek);
  const { loading, tickets, open } = useSelector((state) => state?.fuse?.nivelService?.ticketModal);

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);

  useEffect(() => {
    dispatch(getNotifications({ idUser: id, roleId }));
    initTotalTickets();
    initGraphicTickets();
    initGraphicPerWeekTickets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCloseModal = () => {
    dispatch(openTicketModal(open));
  };

  return (
    <>
      <div className="flex-col m-10 rounded-lg mt-0" style={{ backgroundColor: darkMode ? 'rgb(17, 24, 39)' : 'white' }}>
        {dataNivelService?.error?.name === 'AxiosError' ? (
          <>
            <div className="flex mb-4" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Loader nameComponent="totalTickets" nameLabel="Total de Tickets" loader={loaderTickets} />
            </div>
          </>
        ) : (
          <WrapperTotalTickets>
            <div className="section-title">
              <h1>Total de tickets</h1>
            </div>
            <div className="section-tickets">
              {dataNivelService?.totalTickets?.map((data, index) => (
                <div className="w-1/4 justify-center" key={index}>
                  <strong>{data.nameTicket}</strong>
                  <div key={index} className="ticket-section" style={{ backgroundColor: data.colorTicket }}>
                    <strong className="white-text">{data.totalTicket}</strong>
                  </div>
                </div>
              ))}
            </div>
          </WrapperTotalTickets>
        )}
        {dataNivelService?.error?.name === 'AxiosError' ? (
          <>
            <div className="flex mb-4" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Loader nameComponent="graficaTickets" nameLabel="Grafica de Tickets" loader={loaderTotalTickets} />
            </div>
          </>
        ) : (
          <TotalByStatus bystatus={dataNivelService?.totalTickets} />
        )}
        {dataNivelService?.error?.name === 'AxiosError' ? (
          <>
            <div className="flex mb-4" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Loader nameComponent="graficaTicketsWeek" nameLabel="Tickets por Semana" loader={loaderTotalWeekTickets} />
            </div>
          </>
        ) : (
          <TotalByTotal bytotal={dataNivelService?.graphicPerWeekTickets} />
        )}
        <TicketsModal openModal={open} handleCloseModal={handleCloseModal} loading={loading} ticketsData={tickets} />
      </div>
    </>
  );
};

export default Index;
